<template>
  <HabilitationsAdmin
    v-if="token"
    :auto-run="autoRun"
    :jwt-token="token"
    :context="contextApp"
    :context-hidden="true"
    v-bind="routeProps"
    @identifiant-changed="(value) => (routeProps = { ...routeProps, identifiant: value })"
    @mode-changed="(value) => (routeProps = { ...routeProps, mode: value })"
    @query-changed="onQueryChanged"
  />
  <Teleport to="#app">
    <HabilitationsAdd />
  </Teleport>
</template>

<script setup lang="ts">
  import { computed, onBeforeMount, onBeforeUnmount, ref, shallowRef } from 'vue'
  import { storeToRefs } from 'pinia'
  import router from '@/router'
  import { onBeforeRouteUpdate } from 'vue-router'
  import HabilitationsAdmin from './HabilitationsAdmin.vue'
  import { useHabilitationsAdminInitStore } from './useHabilitationsAdminInitStore'
  import { useAppStateStore } from '@/features/application'
  import { typeContextCourantToContextAppType, TypesContextesAutorisesEnum } from '@/features/auth/context-app'
  import { type HabilitationsAdminMode, type QueryChangedEventArg } from './HabilitationsAdmin.type'
  import HabilitationsAdd from '@/features/interface/profil-utilisateur/admin/HabilitationsAdd.vue'

  const store = useHabilitationsAdminInitStore()
  const appContext = useAppStateStore()
  const { contextCourant } = storeToRefs(appContext)
  const autoRun = ref(false)

  const { token } = storeToRefs(store)
  const contextApp = computed(() => {
    const existContext = [TypesContextesAutorisesEnum.Adherent, TypesContextesAutorisesEnum.Prestataire].includes(
      contextCourant.value,
    )
    if (existContext) return typeContextCourantToContextAppType(contextCourant.value)
    return undefined
  })

  const routeProps = shallowRef<{ mode?: HabilitationsAdminMode; identifiant?: string }>({ mode: 'entite' })
  const onQueryChanged = (isReady: boolean, query: QueryChangedEventArg) => {
    if (isReady) {
      router.push({
        name: 'Administration',
        params: { context: query.context, identifiant: query.identifiant, mode: query.mode },
      })
    }
  }

  onBeforeMount(async () => {
    const mode = (router.currentRoute.value.params.mode as any) || 'entite'
    const identifiant = (router.currentRoute.value.params.identifiant as string) || undefined
    routeProps.value = {
      mode,
      identifiant,
    }
    autoRun.value = true
    await store.start()
  })

  onBeforeRouteUpdate((to, _from) => {
    const identifiant = (to.params.identifiant as string) || undefined
    const mode = (to.params.mode as any) || 'entite'
    routeProps.value = {
      mode,
      identifiant,
    }
  })

  onBeforeUnmount(() => {
    store.stop()
  })
</script>
